<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Employee ID-->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <input pInputText 
               readonly
               id="employeeId" name="employeeId"
               class="p-inputtext-sm"
               [(ngModel)]="employee.id" />
        <label for="employeeId">Employee ID</label>
      </span>
    </div>

    <!--Show in Roster-->
    <div class="p-field-checkbox p-md-offset-1 p-col-12 p-md-2">
      <p-checkbox [(ngModel)]="employee.showInRoster" binary="true" inputId="showInRoster" name="showInRoster"></p-checkbox>
      <label for="showInRoster">Show In Roster</label>
    </div>

    <!--Work Area-->
    <div class="p-field p-col-12 p-md-offset-3 p-md-4">
      <span class="p-float-label">
        <p-dropdown #workAreaDD [options]="workAreas" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="workArea" 
                    name="workArea"
                    optionLabel="areaName"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    [filter]="true"
                    required
                    #workArea="ngModel"
                    [(ngModel)]="employee.workArea"
                    [class.field-error]="form.submitted && workArea.hasError('required')"></p-dropdown>
        <label for="workArea" class="required-field">Work Area</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && workArea.hasError('required')">Work area is required</small>
    </div>
  </div> 

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Employee Payroll No-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <input  pInputText
                id="employeeNo" name="employeeNo"
                class="p-inputtext-sm"
                required
                #employeeNo="ngModel"
                [(ngModel)]="employee.employeeNo"
                [class.field-error]="form.submitted && employeeNo.hasError('required')"/>
        <label for="employeeNo" class="required-field">Employee Payroll No</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && employeeNo.hasError('required')">Employee No is required</small>
    </div>

    <!--Access Id -->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <input  pInputText
                id="accessId" name="accessId"
                class="p-inputtext-sm"
                [(ngModel)]="employee.accessId"/>
        <label for="accessId">Access ID</label>
      </span>
    </div>

    <!--Company-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-dropdown [options]="employers" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="employer"
                    name="employer"
                    optionLabel="employerName"
                    [filter]="true"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    #employer="ngModel"
                    [(ngModel)]="employee.employer"></p-dropdown>
        <label for="employer">Company</label>
      </span>
    </div>

    <!--Roster Type-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown #rosterTypeDD [options]="rosterTypes" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="rosterType" 
                    name="rosterType"
                    optionLabel="title"
                    dataKey="id"
                    [filter]="true"
                    (onChange)="setRosterTypeStartDate(rosterTypeDD)"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="employee.rosterType"></p-dropdown>
        <label for="state" class="bold-field blue-field">Roster Type</label>
      </span>
    </div>
  </div> 

  <!-- Row 3 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--First Name-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <input  pInputText
                id="firstName" name="firstName"
                class="p-inputtext-sm"
                required
                #firstName="ngModel"
                [(ngModel)]="employee.firstName"
                [class.field-error]="form.submitted && firstName.hasError('required')"/>
        <label for="firstName" class="required-field">First Name</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && firstName.hasError('required')">First Name is required</small>
    </div>

    <!--Middle Name -->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <input  pInputText
                id="middleName" name="middleName"
                class="p-inputtext-sm"
                [(ngModel)]="employee.middleName"/>
        <label for="middleName">Middle Name</label>
      </span>
    </div>

    <!--Last Name-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <input  pInputText
                id="lastName" name="lastName"
                class="p-inputtext-sm"
                required
                #lastName="ngModel"
                [(ngModel)]="employee.lastName"
                [class.field-error]="form.submitted && lastName.hasError('required')"/>
        <label for="lastName" class="required-field">Last Name</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && lastName.hasError('required')">Last Name is required</small>
    </div>

    <!--Roster Type Start Date-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm"
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="rosterTypeStartDate"
                    name="rosterTypeStartDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    [(ngModel)]="employee.rosterTypeStartDate"></p-calendar>
        <label for="rosterTypeStartDate" class="bold-field blue-field">Roster Type Start Date</label>
      </span>
    </div>
  </div> 

  <!-- Row 4 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Street Address -->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <input  pInputText
                id="address" name="address"
                class="p-inputtext-sm"
                [(ngModel)]="employee.address"/>
        <label for="address">Street Address</label>
      </span>
    </div>

    <!--City -->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <input  pInputText
                id="city" name="city"
                class="p-inputtext-sm"
                [(ngModel)]="employee.city"/>
        <label for="city">City</label>
      </span>
    </div>
    <!--State/Territory-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown [options]="states" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="state" 
                    name="state"
                    optionLabel="name"
                    dataKey="code"
                    [autoDisplayFirst]="false"
                    [filter]="true"
                    [(ngModel)]="employee.state"></p-dropdown>
        <label for="state">State/Territory</label>
      </span>
    </div>
    <!--Post Code-->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputMask mask="9999"
                     id="postcode" name="postcode"
                     class="p-inputtext-sm"
                     [(ngModel)]="employee.postcode"></p-inputMask>
        <label for="postcode">Postcode</label>
      </span>
    </div>
  </div> 

  <!-- Row 5 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Employee Group -->
    <div class="p-field p-col-12 p-md-5">
      <span class="p-float-label">
        <p-dropdown [options]="groups" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="workGroup"
                    name="workGroup"
                    optionLabel="name"
                    [filter]="true"
                    dataKey="id"
                    required
                    #workGroup="ngModel"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="employee.workGroup"
                    [class.field-error]="form.submitted && workGroup.invalid"></p-dropdown>
        <label for="workGroup" class="required-field">Employee Group</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && workGroup.invalid">Employee must belong to a group!</small>
    </div>
    <!--Supervisor-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown [options]="supervisors" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="supervisor" 
                    name="supervisor"
                    optionLabel="name"
                    [filter]="true"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="employee.supervisor">
          <ng-template let-supervisor pTemplate="item">
            <span >{{ getEmployeeName(supervisor) }}{{supervisor.active ? "" : " - (inactive)"}}</span>
          </ng-template>        
        </p-dropdown>
        <label for="supervisor">Supervisor</label>
      </span>
    </div>

    <!--Hire Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="hireDate"
                    name="hireDate"
                    [maxDate]="maxDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true"
                    required 
                    #hireDate="ngModel"
                    [(ngModel)]="employee.hireDate"
                    [class.field-error]="form.submitted && hireDate.hasError('required')"></p-calendar>
        <label for="hireDate" class="required-field">Hire Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && hireDate.invalid">Hire date is required!</small>
    </div>
  </div> 

  <!-- Row 6 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Position -->
    <div class="p-field p-col-12 p-md-5">
      <span class="p-float-label">
        <p-dropdown [options]="positions" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="position"
                    name="position"
                    optionLabel="title"
                    [filter]="true"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    required
                    #position="ngModel"
                    [(ngModel)]="employee.position"
                    [class.field-error]="form.submitted && position.invalid"></p-dropdown>
        <label for="position" class="required-field">Position</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && position.invalid">Employee must have a position!</small>
    </div>

    <!--Position Start Date-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="positionStartDate"
                    name="positionStartDate"
                    [maxDate]="maxDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    [(ngModel)]="employee.positionStartDate"></p-calendar>
        <label for="positionStartDate">Position Start Date</label>
      </span>
    </div>

    <!--Contract Expire Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="contractExpireDate"
                    name="contractExpireDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    [(ngModel)]="employee.contractExpireDate"></p-calendar>
        <label for="contractExpireDate">Contract Expire Date</label>
      </span>
    </div>
  </div> 

  <!-- Row 7 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Email-->
    <div class="p-field p-col-12 p-md-7">
      <span class="p-float-label">
        <input  pInputText
                id="email" name="email"
                class="p-inputtext-sm"
                [(ngModel)]="employee.email"/>
        <label for="email">Email</label>
      </span>
    </div>

    <!--Phone-->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <input  pInputText
                id="phone" name="phone"
                class="p-inputtext-sm"
                [(ngModel)]="employee.phone" />
        <label for="phone">Phone</label>
      </span>
    </div>

    <!--Birth Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="dateOfBirth"
                    name="dateOfBirth"
                    [yearNavigator]="true" yearRange="1940:2030"
                    [monthNavigator]="true" 
                    [(ngModel)]="employee.dateOfBirth"></p-calendar>
        <label for="dateOfBirth">Date of Birth</label>
      </span>
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
